import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import NoRecord from "../../../components/other/NoRecord";
import { useLocation, useNavigate } from "react-router-dom";
import { addToCart, fetchProducts } from "../../../redux/action/orderAction";
import { curSym, pipErrorMessage, pipGetAccessToken } from "../../../utils/pip";
import {
  decreaseQuantity,
  increaseQuantity,
  setSelectedProduct,
} from "../../../redux/reducers/orderReducer";

const ProductSection = ({ isSingleProductPage = false, onClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { selectedProduct, productDetails } = useSelector(
    (state) => state.orderReducer
  );
  const { products } = useSelector((state) => state.orderReducer);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleAddToCart = (product) => {
    if (pipGetAccessToken()) {
      const callback = (response) => {
        if (response.success);
        setIsModalVisible(false);
        dispatch(fetchProducts());
      };
      const data = {
        product_id: product?.id,
        quantity: product?.cartQuanity,
      };
      dispatch(
        addToCart({
          payload: data,
          callback,
        })
      );
    } else {
      pipErrorMessage("You need to log in before adding items to the cart.");
      // navigate(pageRoutes?.login)
      return;
    }
  };

  const ProductCard = ({ product }) => {
    return (
      <div className="col-12 col-md-4 col-lg-3 mb-4">
        <div className="ct_product_card">
          <figure className="mb-0">
            <div className="ct_product_img">
              <img
                src={product?.product_images?.thumbnail}
                alt={product?.product_name}
              />
              <div className="ct_product_btn_group">
                <button
                  className="ct_add_to_cart_btn"
                  onClick={() => {
                    dispatch(setSelectedProduct(product));
                    handleOpenModal();
                  }}
                >
                  <span>Quick View</span>
                  <span>
                    <i className="fa-solid fa-eye"></i>
                  </span>
                </button>
                <button
                  className="ct_add_to_cart_btn mt-2"
                  type="button"
                  onClick={() => {
                    dispatch(setSelectedProduct(product));
                    handleAddToCart(product);
                  }}
                >
                  <span>Add to cart</span>
                  <span>
                    <i className="fa-solid fa-cart-shopping"></i>
                  </span>
                </button>
              </div>
            </div>
            <figcaption>
              <div className="ct_review_star mb-3">
                <Rating
                  allowFraction
                  readonly
                  initialValue={parseFloat(product?.total_rating)} // Use directly if already between 0-5
                  size={30}
                />
              </div>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  if (isSingleProductPage) {
                    return onClick(product?.id);
                  }
                  navigate(pageRoutes?.shop?.productDetails, {
                    state: { id: product?.id },
                  });
                }}
              >
                <h5>{product?.product_name}</h5>
              </a>
              <div className="product-price">
                <ins className="new-price">
                  {curSym}{" "}
                  {parseFloat(product?.price) - parseFloat(product?.discount)}
                </ins>
                <del className="old-price">
                  {curSym}
                  {product?.price}
                </del>
              </div>
            </figcaption>
          </figure>
        </div>
      </div>
    );
  };
  return (
    <>
      <div class="untree_co-section product-section py-5">
        <div class="container">
          {pathname == pageRoutes.getStarted.goodKidsToStart && (
            <>
              <div className="ms-auto text-end mb-3">
                {" "}
                <button className="btn btn-secondary ct_btn_animate  ms-auto">
                  See More
                </button>
              </div>
            </>
          )}

          <div class="row">
            {products?.length > 0 ? (
              pathname == pageRoutes.getStarted.goodKidsToStart ? (
                <>
                  {products?.slice(0, 4).map((product) => (
                    <ProductCard key={product?.id} product={product} />
                  ))}
                </>
              ) : (
                products?.map((product) => (
                  <ProductCard key={product?.id} product={product} />
                ))
              )
            ) : (
              <NoRecord className="text-center" />
            )}
          </div>
        </div>
      </div>

      {isModalVisible && (
        <div
          class="modal fade show ct_custom_modal_back"
          id="ct_quick_view"
          style={{ display: "block" }}
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header border-0 py-0">
                <button
                  type="button"
                  class="btn-close ct_close_btn"
                  onClick={() => handleCloseModal()}
                ></button>
              </div>
              <div class="modal-body border-0 pt-5 ">
                <div class="ct_quick_view_modal">
                  <div class="ct_quick_view_img">
                    <img
                      src={
                        selectedProduct?.product_images?.thumbnail ??
                        "images/Robotic_img/product_1.png"
                      }
                      alt=""
                    />
                  </div>
                  <div class="ct_quick_view_product_info">
                    <div class="ct_signle_product_detail">
                      <h5>{selectedProduct?.related_name ?? ""}</h5>
                      <h3>{selectedProduct?.product_name ?? ""}</h3>
                      <h2>
                        {curSym + " "}
                        {parseFloat(selectedProduct?.price) -
                          parseFloat(selectedProduct?.discount)}
                      </h2>
                      <p>{selectedProduct?.description ?? ""}</p>
                      <div>
                        <p class="mb-0">SKU: {selectedProduct?.sku ?? ""}</p>
                        <p class="d-flex align-items-center flex-wrap gap-2">
                          Categories:{" "}
                          <span>
                            {selectedProduct?.category?.category_name ?? ""}
                          </span>
                        </p>
                      </div>
                      <div class="ct_flex_2">
                        <div
                          class="input-group ct_quntity_count1 d-flex align-items-center quantity-container ms-0"
                          style={{ maxWidth: "120px" }}
                        >
                          <div class="input-group-prepend">
                            <button
                              class="decrease"
                              type="button"
                              onClick={() =>
                                dispatch(decreaseQuantity(selectedProduct?.id))
                              }
                            >
                              −
                            </button>
                          </div>
                          <input
                            type="text"
                            class="form-control text-center quantity-amount"
                            value={selectedProduct?.cartQuanity}
                            placeholder="0"
                            aria-label="Example text with button addon"
                            aria-describedby="button-addon1"
                          />
                          <div class="input-group-append">
                            <button
                              class=" increase"
                              type="button"
                              onClick={() =>
                                dispatch(increaseQuantity(selectedProduct?.id))
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <button
                          class="ct_single_cart_btn ct_white__space_nowrap"
                          type="button"
                          onClick={() => handleAddToCart(selectedProduct)}
                        >
                          <i class="fa-solid fa-cart-shopping"></i> Add to cart
                        </button>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductSection;
